var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "txt-doc", class: _vm.mixClasses },
    [
      _c(
        _vm.component,
        _vm._b(
          { tag: "component", staticClass: "txt-doc__txt" },
          "component",
          _vm.$attrs,
          false
        ),
        [
          _c("span", { staticClass: "text-content" }, [
            _vm._v("\n      " + _vm._s(_vm.text) + "\n    "),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "new-doc" }, [
            _vm._v(_vm._s(_vm.$t("tenantProjects.docs"))),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }